import React from 'react';
import { StatusTag } from '../../../../../components/common/StatusTag';
import * as S from './styled';
export const OfferStatuses = ({ offer }) => (React.createElement("div", null,
    React.createElement(S.Tags, null,
        React.createElement(S.Tag, null,
            React.createElement(StatusTag, { status: offer.state.status, isSoldOut: !offer.state.available })))));
